import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { IBusiness } from '../../../models';
import { DateFormatPipe } from "../../../helper/pipes/date-format/date-format-pipe";
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-business-quick-view',
  imports: [DateFormatPipe, MatDialogModule, CommonModule, MatButtonModule],
  templateUrl: './business-quick-view.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './business-quick-view.component.scss',
})
export class BusinessQuickViewComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    title: string,
    businesses: IBusiness[]
  }) { }

}
